module.exports = __webpack_public_path__ + "img/painPerceptionScale_0.f2a35418.png";